<template>
  <el-card style="height: 710px; overflow-y: scroll">
    <div class="region">
      <p>OCR脱敏规则管理</p>
      <div class="form">
        <el-form inline>
          <el-form-item label="替换文字">
            <el-input
              placeholder="请输入"
              v-model="text"
              style="width: 280px"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getRegionData">查看</el-button>
            <el-button @click="searchReset">清空</el-button>
          </el-form-item>
        </el-form>
      </div>

      <el-button type="primary" class="add_button" @click="dialogVisible = true"
        >新增规则</el-button
      >
      <el-table
        border
        :data="tableData"
        :header-cell-style="{ 'background-color': '#f6f6f6' }"
        style="width: 100%; margin-top: 20px"
      >
        <el-table-column
          align="center"
          prop="text"
          label="替换内容"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="re"
          label="正则表达式"
        ></el-table-column>
        <el-table-column align="center" prop="address" label="操作">
          <template slot-scope="scope">
            <el-button
              @click="editRegionShow(scope.row)"
              type="text"
              class="button"
              >编辑</el-button
            >
            <el-button
              @click="deleteRegion(scope.row.id)"
              type="text"
              class="button"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        :current-page="current_page"
        layout="prev, pager, next"
        :page-size="pageSize"
        hide-on-single-page
        @current-change="changePage"
        @prev-click="changePage"
        @next-click="changePage"
        :total="total"
      >
      </el-pagination>

      <el-dialog
        :modal="false"
        :title="dialogType"
        class="dialog"
        :visible.sync="dialogVisible"
        :show-close="false"
        @close="closeDialog"
        width="30%"
      >
        <el-form :model="form">
          <el-form-item label="正则表达式">
            <el-input
              placeholder="请输入"
              style="width: 80%"
              v-model="form.re"
            ></el-input>
          </el-form-item>
          <el-form-item label="匹配文字">
            <el-input
              placeholder="请输入"
              style="width: 80%"
              v-model="form.text"
            ></el-input>
          </el-form-item>
        </el-form>
        <el-row
          class="buttons"
          type="flex"
          align="middle"
          justify="end"
          style="margin-right: 30px"
        >
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="submitRegionForm">确定</el-button>
        </el-row>
      </el-dialog>
    </div>
  </el-card>
</template>

<script>
import {
  get_desensitization,
  create_desensitization,
  edit_desensitization,
  delete_desensitization,
} from "@/api/OCRDesensitization";

export default {
  name: "OCRDesensitizationView",
  data: function () {
    return {
      tableData: [],
      page: 1,
      pageSize: 10,
      total: 0,
      current_page: 1,
      text: "",
      form: {
        text: "",
        re: "",
      },
      dialogVisible: false,
      dialogType: "",
    };
  },
  methods: {
    getRegionData() {
      get_desensitization(this.page, this.pageSize, this.text).then((res) => {
        const { data } = res;
        if (data["code"] === 200) {
          this.tableData = data["data"];
          this.total = data["count"];
        }
      });
    },
    searchReset() {
      this.text = "";
      this.getRegionData();
    },
    closeDialog() {
      this.form = {
        re: "",
        text: "",
      };
      this.dialogVisible = false;
    },
    submitRegionForm() {
      let fn;
      if (this.form.id) {
        fn = edit_desensitization;
      } else {
        fn = create_desensitization;
      }
      fn(this.form.text, this.form.re, this.form.id).then((res) => {
        const { data } = res;
        if (data["code"] === 200) {
          this.$message.success(data["message"]);
          this.dialogVisible = false;
          this.getRegionData();
        } else {
          this.$message.error(data["error"]);
        }
      });
    },
    editRegionShow(row) {
      this.form = row;
      this.dialogVisible = true;
    },
    deleteRegion(id) {
      delete_desensitization(id).then((res) => {
        const { data } = res;
        if (data["code"] === 200) {
          this.$message.success("删除成功！");
          this.getRegionData();
        }
      });
    },
    changePage(page) {
      this.page = page;
      this.getRegionData();
    },
  },
  created() {
    this.getRegionData();
  },
  computed: {},
  watch: {},
};
</script>

<style lang="scss" scoped>
.el-card {
  width: 99%;
}
</style>
